<template>
  <div class="orgextenstion">
    <div class="content">
      <div class="title">{{$t('外延服务')}}</div>
      <div class="info">
        {{$t('为综合性运动会、各种项目的所有赛制，建立竞赛设备物联网，线上线下数据互联互通')}}
      </div>
    </div>
    <div class="grid">
      <div class="org-grid">
        <div
          class="org-grid-item"
          v-for="(item, index) in orgGridList"
          :key="index"
          :class="(index + 1) % 6 == 0 ? 'org-grid-right' : ''"
        >
          {{ $t(item.name) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orgGridList: [
        { name: '保险团购' },
        { name: '奖杯 奖牌设计制作' },
        { name: '赛事整体VI设计及制作' },
        { name: '酒店预订' },
        { name: '赛场导航' },
        { name: '餐厅预订' },
        { name: '智能叫车' },
        { name: '酒店自动入驻' },
        { name: '自动退房' },
        { name: '网上签到' },
        { name: '赛事财务统计' },
        { name: '' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.orgextenstion {
  width: 100%;
  margin-bottom: 60px;
background-color: #ECECEC;
  .content {
    width: 1200px;
    height: 216px;
    margin: 0 auto;
    text-align: center;
    padding-top: 60px;
    .title {
      font-size: 44px;
      font-weight: 300;
    }
    .info {
      color: #333333;
      font-size: 16px;
      font-weight: 400;
      line-height: 60px;
    }
  }
  .grid {
    background-color: #404040;
    .org-grid {
      margin: 0 auto;
      width: 1200px;
      color: white;
      height: 280px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      .org-grid-item {
        width: 200px;
        height: 140px;
        box-sizing: border-box;
        padding: 20px 20px;
        border-top: 1px solid #999999;
        border-left: 1px solid #999999;
      }
      .org-grid-right {
        border-right: 1px solid #999999;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/detail/components/Orgextension.vue